import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'role-details-page';
export const useRoleDetailsPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);
export const ruRu = (__LOCALE_RU__ ? ({
  [ns]: {
    role_list: 'Роли',
    is_system: 'Системная',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [ns]: {
    role_list: 'Roles',
    is_system: 'System',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [ns]: {
    role_list: 'Roles',
    is_system: 'Sistémico',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [ns]: {
    role_list: 'Funções',
    is_system: 'Sistêmico',
  },
}) : {}) as Record<string, unknown>;
